export enum TopCountriesPeriod {
  "TwentyEightDays" = "TwentyEightDays",
  "OneYear" = "OneYear",
  "AllTime" = "AllTime"
}